import React from "react";
import { Button, Input } from "antd";
import "./linkpage.scss";

function SearchLinks(props) {
  return (
    <div className="px-lg-4 py-4 px-0 search-field m-0">
      <div className="d-flex w-100 sub-header">
        <div className="d-flex align-items-center row flex-1">
          <div className="d-flex align-items-center col-lg-4 col-md-12 pb-lg-0 pb-md-3 pb-3 col-12">
            <div className="pe-2 ps-0 flex-1">
              <Input
                className="w-100"
                placeholder={props.placeholder}
                onChange={props.handleSearch}
                allowClear
              />
            </div>
            <Button onClick={props.handleSearchlinks} data-telemetry="Search Link Initiatives">Search</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchLinks;
